import { render, staticRenderFns } from "./StatisticsCardLineChart.vue?vue&type=template&id=1635fa52&"
import script from "./StatisticsCardLineChart.vue?vue&type=script&lang=js&"
export * from "./StatisticsCardLineChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports